import { videoManagement } from '@/api'

const state = {
  videoTemplateList: [],
  videoStatusMap: {
    CREATING: '创建中',
    DRAFT: '创意草稿',
    VIDEO_GENERATING: '生成中...',
    ALL_COMPLETED: '已完成',
    CREATE_FAILED: '生成失败'
  },
  dubList: [], // 旁白列表
  musicList: [], // 配乐列表
}
// getters
const getters = {
  videoStatusList: state => {
    return state.videoStatusMap && Object.keys(state.videoStatusMap).map(key => ({
      value: key,
      label: state.videoStatusMap[key]
    }));
  }
}
// actions
const actions = {
  getVideoTemplateList(context, cid) {
    return videoManagement.getTemplateList(cid).then(({ data }) => {
      if (data.status === 0) {
        context.commit('setVideoTemplateList', { list: data.result })
      }
    })
  },
  getDubList(context, dictCode) {
    return videoManagement.getDictList(dictCode).then(({ data }) => {
      if (data.status === 0) {
        context.commit('setDubList', { list: data.result })
      }
    })
  },
  getMusicList(context, dictCode) {
    return videoManagement.getDictList(dictCode).then(({ data }) => {
      if (data.status === 0) {
        context.commit('setMusicList', { list: data.result })
      }
    })
  }
}

// mutations
const mutations = {
  setVideoTemplateList(state, data) {
    state.videoTemplateList = data.list
  },
  setDubList(state, data) {
    state.dubList = data.list
  },
  setMusicList(state, data) {
    if (data.list) {
      state.musicList = data.list.reverse()
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
